const SYNCHRONIZE = 60 * 1000; // 1 minute
const SETTING = 60 * 1000; // 1 minute
const FIRMWARE = 3 * 24 * 60 * 60 * 1000; // 3 days
const CONNECTED = 60 * 1000; // 1 minute
const SYNCHRONIZE_UPDATE = 60 * 1000; // 1 minute

export default {
    SYNCHRONIZE,
    SETTING,
    FIRMWARE,
    CONNECTED,
    SYNCHRONIZE_UPDATE,
};
